import z from "zod";

export const transportAutoEntriesCompleteSchema = z.object({
  current_equipment_usage: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  observations: z.string().optional(),
  photos: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File | string>().optional().nullable(),
    }),
  ).optional().nullable(),
});

export type TransportAutoEntriesCompleteValidationSchema = z.infer<typeof transportAutoEntriesCompleteSchema>;
